import get from 'lodash.get';
import { emptyArray } from '../../default-props/empty';

export const selectIsOpen = (state) => get(state, 'isOpen', false);
export const selectBatches = (state) => get(state, 'batches', emptyArray);
export const selectSelectedBatches = (state) => get(state, 'selectedBatches', emptyArray);
export const selectFromProcessDate = (state) => get(state, 'fromProcessDate', false);
export const selectPageSize = (state) => get(state, 'pageSize', false);
export const selectIsLoading = (state) => get(state, 'isLoading', false);
export const selectWarnOrErrorByBatchId = (state, props) => {
  const { batchId } = props;
  const warnOrErrors = state.errorsAndWarnings || [];
  return warnOrErrors.find((err) => err.batchId === batchId);
};
export const selectIsLabelFetchingComplete = (state) => get(state, 'isLabelFetchComplete', false);
